import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class QuotationQueries {

  listQuotations(): DocumentNode {
    return gql`
      query listQuotations(
        $where: QuotationWhereInput,
        $orderBy: QuotationOrderByInput,
        $limit: Int,
        $offset: Int
      ) {
        quotations(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
          totalCount
          items {
            id
            identifier
            total
            status
            createdAt
            createdAt
            expiredAt
            company {
              id
              name
            }
            location {
              id
              name
            }
            maintenance {
              id,
              number
            }
            labels {
              name
              color
            }
          }
        }
      }
    `;
  }

  getQuotationAttachments(): DocumentNode {
    return gql`
      query getQuotationAttachments($id: ID!) {
        quotation(id: $id) {
          id
          attachments {
            id
            title
            path
            position
            archived
            type
            createdAt
          }
        }
      }
    `;
  }

  getQuotationById(): DocumentNode {
    return gql`
      query getQuotationById($id: ID!) {
        quotation(id: $id) {
          id
          identifier
          name
          createdAt
          description
          additionalInformation
          updatedByClientApplicationName
          updatedByName
          company {
            id
            name
            avatarUrl
          }
          location {
            id
            name
            address {
              formattedAddress
            }
          }
          maintenance {
            id
            number
            maintenanceType {
              id
              name
              archived
            }
            segment {
              id
              name
              archived
            }
          }
          subTotal
          total
          status
          createdAt
          updatedAt
          expiredAt
          discount {
            type
            value
            total
          },
          labels {
            id
            name
            color
          }
          items {
            id
            description
            quantity
            total
            productServiceValue
            productService {
              id
              name
              type
              archived
              code
            }
          }
          approvedAt
          approvedMessage
          approvedBy {
            id
            name
            avatarUrl
          }
          refusedAt
          refusedBy {
            id
            name
            avatarUrl
          }
        }
      }
    `;
  }

  approveQuotation(): DocumentNode {
    return gql`
      mutation approveQuotation($input: ApproveQuotationInput!) {
        approveQuotation(input: $input) {
          id
        }
      }
    `;
  }

  rejectQuotation(): DocumentNode {
    return gql`
      mutation rejectQuotation($input: RejectQuotationInput!) {
        rejectQuotation(input: $input) {
          id
        }
      }
    `;
  }

  addQuotationLabel(): DocumentNode {
    return gql`
      mutation createQuotationLabels($input: [CreateQuotationLabelInput]!) {
        createQuotationLabels(input: $input) {
          id
        }
      }
    `;
  }

  removeQuotationLabel(): DocumentNode {
    return gql`
      mutation removeQuotationLabel($input: RemoveQuotationLabelInput!) {
        removeQuotationLabel(input: $input) {
          id
        }
      }
    `;
  }
}
